import { Field } from 'formik';
import React from 'react';
import CustomRadio from '../../../../common/ui/CustomRadio';

const LargeTextExtraSetting = ({ values, setFieldValue }) => {
  return (
    <div className=" col-md-6 col-lg-6 col-sm-12 col-xs-12 pt-3 d-flex align-items-center ">
      <div className="form-check d-flex align-items-center">
        <CustomRadio label="Use As Textarea" isRadio={true}>
          <Field
            className="form-check-input"
            type="radio"
            name="extraFieldSetting.textareaDisplayType"
            value="text-area"
            id="exampleRadios1"
          />
        </CustomRadio>
        &nbsp;&nbsp;
        <CustomRadio label="Use As WYSIWYG Editor" isRadio={true}>
          <Field
            className="form-check-input"
            type="radio"
            name="extraFieldSetting.textareaDisplayType"
            value="text-editor"
            id="exampleRadios1"
          />
        </CustomRadio>
      </div>
      {/* DROPDOWN */}
      <div className="ml-3" style={{ width: 220 }}>
        <input
          type="number"
          min="1"
          className="form-control custom-select-theme"
          placeholder="Enter Word Limit"
          value={
            values && values.extraFieldSetting && values.extraFieldSetting.maxLength != null
              ? values.extraFieldSetting.maxLength
              : ''
          }
          onChange={(e) =>
            setFieldValue(
              'extraFieldSetting.maxLength',
              e.target.value === '' ? undefined : parseInt(e.target.value, 10),
            )
          }
        />
      </div>
    </div>
  );
};

export default LargeTextExtraSetting;
